import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/developer/ui/input-switch")({
    beforeLoad: () => {
        throw redirect({ to: "/design/forms/inputs", replace: true });
    },
});
